import { t } from "i18next";
import { BeautyIcon, CosmeticMedicineIcon, CuppingIcon, DryNeedlingIcon, FlowerIcon, FlowerReversedIcon, NeedleIcon, PrescriptionIcon } from "../images/svg-components";

export enum Modality {
  NONE = 0,
  MASSAGE = 1,
  ACUPUNCTURE = 2,
  CHINESE_MEDICINE = 3,
  REMEDIAL_MASSAGE = 4,
  DEEP_TISSUE_MASSAGE = 5,
  SPORTS_MASSAGE = 6,
  DRY_NEEDLING = 7,
  CUPPING = 8,
  PREGNANCY_MASSAGE = 9,
  MYOTHERAPY = 10,
  ASSISTED_STRETCHING = 11,
  TRIGGER_PT_THERAPY = 12,
  MYOFASCIAL_RELEASE = 13,
  JOINT_MOBILISATION = 14,
  PHYSIO = 15,
  CHIRO = 16,
  BEAUTY = 17,
  COSMETIC_MEDICINE = 18,
}


export enum ModalityType {
  TCM, MASSAGE, OTHER
}

export const MODALITY_OPTIONS: { id: Modality, title: string, name: string, label: string, icon: any, desc: string, plainTitle: string, shortTitle: string, type: ModalityType, seqNo: number }[] = [
  {
    get title() { return t("MEDICINE"); },
    get name() { return t("MEDICINE"); },
    get label() { return t("MEDICINE"); },
    id: Modality.CHINESE_MEDICINE,
    icon: PrescriptionIcon,
    desc: "PRESCRIBE_MEDICATION_TO_THE_PATIENT",
    plainTitle: "MEDICINE",
    shortTitle: "TCM",
    type: ModalityType.TCM,
    seqNo: 1,
  },
  {
    get title() { return t("ACUPUNCTURE"); },
    get name() { return t("ACUPUNCTURE"); },
    get label() { return t("ACUPUNCTURE"); },
    id: Modality.ACUPUNCTURE,
    icon: NeedleIcon,
    desc: "PRESCRIBE_ACUPUNCTURE_TO_THE_PATIENT",
    plainTitle: "ACUPUNCTURE",
    shortTitle: "ACU",
    type: ModalityType.MASSAGE,
    seqNo: 2,
  },
  {
    get title() { return t("MASSAGE"); },
    get name() { return t("MASSAGE"); },
    get label() { return t("MASSAGE"); },
    id: Modality.MASSAGE,
    icon: FlowerIcon,
    desc: "PRESCRIBE_MASSAGE_TO_THE_PATIENT",
    plainTitle: "MASSAGE",
    shortTitle: "MAS",
    type: ModalityType.MASSAGE,
    seqNo: 3,
  },
  {
    get title() { return t("REMEDIAL_MASSAGE_OPTION"); },
    get name() { return t("REMEDIAL_MASSAGE"); },
    get label() { return t("REMEDIAL_MASSAGE"); },
    id: Modality.REMEDIAL_MASSAGE,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_REMEDIAL_MASSAGE_TO_THE_PATIENT",
    plainTitle: "REMEDIAL_MASSAGE",
    shortTitle: "RMAS",
    type: ModalityType.MASSAGE,
    seqNo: 4,
  },
  {
    get title() { return t("CUPPING"); },
    get name() { return t("CUPPING"); },
    get label() { return t("CUPPING"); },
    id: Modality.CUPPING,
    icon: CuppingIcon,
    desc: "PRESCRIBE_CUPPING_TO_THE_PATIENT",
    plainTitle: "CUPPING",
    shortTitle: "CUP",
    type: ModalityType.MASSAGE,
    seqNo: 5,
  },
  {
    get title() { return t("DRY_NEEDLING"); },
    get name() { return t("DRY_NEEDLING"); },
    get label() { return t("DRY_NEEDLING"); },
    id: Modality.DRY_NEEDLING,
    icon: DryNeedlingIcon,
    desc: "PRESCRIBE_DRY_NEEDLING_TO_THE_PATIENT",
    plainTitle: "DRY_NEEDLING",
    shortTitle: "DN",
    type: ModalityType.MASSAGE,
    seqNo: 6,
  },
  {
    get title() { return t("DEEP_TISSUE_MASSAGE"); },
    get name() { return t("DEEP_TISSUE_MASSAGE"); },
    get label() { return t("DEEP_TISSUE_MASSAGE"); },
    id: Modality.DEEP_TISSUE_MASSAGE,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_DEEP_TISSUE_MASSAGE_TO_THE_PATIENT",
    plainTitle: "DEEP_TISSUE_MASSAGE",
    shortTitle: "DTM",
    type: ModalityType.MASSAGE,
    seqNo: 7,
  },
  {
    get title() { return t("SPORTS_MASSAGE"); },
    get name() { return t("SPORTS_MASSAGE"); },
    get label() { return t("SPORTS_MASSAGE"); },
    id: Modality.SPORTS_MASSAGE,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_SPORTS_MASSAGE_TO_THE_PATIENT",
    plainTitle: "SPORTS_MASSAGE",
    shortTitle: "SPM",
    type: ModalityType.MASSAGE,
    seqNo: 8,
  },
  {
    get title() { return t("PREGNANCY_MASSAGE"); },
    get name() { return t("PREGNANCY_MASSAGE"); },
    get label() { return t("PREGNANCY_MASSAGE"); },
    id: Modality.PREGNANCY_MASSAGE,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_PREGNANCY_MASSAGE_TO_THE_PATIENT",
    plainTitle: "PREGNANCY_MASSAGE",
    shortTitle: "PM",
    type: ModalityType.MASSAGE,
    seqNo: 9,
  },
  {
    get title() { return t("MYOTHERAPY"); },
    get name() { return t("MYOTHERAPY"); },
    get label() { return t("MYOTHERAPY"); },
    id: Modality.MYOTHERAPY,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_MYOTHERAPY_TO_THE_PATIENT",
    plainTitle: "MYOTHERAPY",
    shortTitle: "MYO",
    type: ModalityType.MASSAGE,
    seqNo: 10,
  },
  {
    get title() { return t("ASSISTED_STRETCHING"); },
    get name() { return t("ASSISTED_STRETCHING"); },
    get label() { return t("ASSISTED_STRETCHING"); },
    id: Modality.ASSISTED_STRETCHING,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_ASSISTED_STRETCHING_TO_THE_PATIENT",
    plainTitle: "ASSISTED_STRETCHING",
    shortTitle: "ASSG",
    type: ModalityType.MASSAGE,
    seqNo: 11,
  },
  {
    get title() { return t("TRIGGER_PT_THERAPY"); },
    get name() { return t("TRIGGER_PT_THERAPY"); },
    get label() { return t("TRIGGER_PT_THERAPY"); },
    id: Modality.TRIGGER_PT_THERAPY,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_TRIGGER_PT_THERAPY_TO_THE_PATIENT",
    plainTitle: "TRIGGER_PT_THERAPY",
    shortTitle: "TPT",
    type: ModalityType.MASSAGE,
    seqNo: 12,
  },
  {
    get title() { return t("MYOFASCIAL_RELEASE"); },
    get name() { return t("MYOFASCIAL_RELEASE"); },
    get label() { return t("MYOFASCIAL_RELEASE"); },
    id: Modality.MYOFASCIAL_RELEASE,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_MYOFASCIAL_RELEASE_TO_THE_PATIENT",
    plainTitle: "MYOFASCIAL_RELEASE",
    shortTitle: "MFR",
    type: ModalityType.MASSAGE,
    seqNo: 13,
  },
  {
    get title() { return t("JOINT_MOBILISATION"); },
    get name() { return t("JOINT_MOBILISATION"); },
    get label() { return t("JOINT_MOBILISATION"); },
    id: Modality.JOINT_MOBILISATION,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_JOINT_MOBILISATION_TO_THE_PATIENT",
    plainTitle: "JOINT_MOBILISATION",
    shortTitle: "JM",
    type: ModalityType.MASSAGE,
    seqNo: 14,
  },
  {
    get title() { return t("PHYSIO"); },
    get name() { return t("PHYSIO"); },
    get label() { return t("PHYSIO"); },
    id: Modality.PHYSIO,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_PHYSIO_TO_THE_PATIENT",
    plainTitle: "PHYSIO",
    shortTitle: "PHY",
    type: ModalityType.MASSAGE,
    seqNo: 15,
  },
  {
    get title() { return t("CHIRO"); },
    get name() { return t("CHIRO"); },
    get label() { return t("CHIRO"); },
    id: Modality.CHIRO,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_CHIRO_TO_THE_PATIENT",
    plainTitle: "CHIRO",
    shortTitle: "CHI",
    type: ModalityType.MASSAGE,
    seqNo: 16,
  },
  {
    get title() { return t("BEAUTY"); },
    get name() { return t("BEAUTY"); },
    get label() { return t("BEAUTY"); },
    id: Modality.BEAUTY,
    icon: BeautyIcon,
    desc: "PRESCRIBE_BEAUTY_TO_THE_PATIENT",
    plainTitle: "BEAUTY",
    shortTitle: "BEA",
    type: ModalityType.OTHER,
    seqNo: 17,
  },
  {
    get title() { return t("COSMETIC_MEDICINE"); },
    get name() { return t("COSMETIC_MEDICINE"); },
    get label() { return t("COSMETIC_MEDICINE"); },
    id: Modality.COSMETIC_MEDICINE,
    icon: CosmeticMedicineIcon,
    desc: "PRESCRIBE_COSMETIC_MEDICINE_TO_THE_PATIENT",
    plainTitle: "COSMETIC_MEDICINE",
    shortTitle: "CM",
    type: ModalityType.OTHER,
    seqNo: 18,
  },
];